import { formatComparisonLevelForDisplay } from "../../../../utils/surveyConfiguration";

export const getThresholdValueStarted = (state, payload) => {
  return {
    ...state,
    thresholdApi:{
      ...state.thresholdApi,
      isProcessing: true,
      error:false
    }
  };
};

export const getThresholdValueSuccess = (state, payload) => {
  let heatmapConfig = payload.response && payload.response.heatmapConfiguration ? payload.response.heatmapConfiguration : state.heatmapConfiguration
  let trendHeatmapConfig = payload.response && payload.response.trendHeatmapConfiguration ? payload.response.trendHeatmapConfiguration : state.trendHeatmapConfiguration
  payload.response = { ...payload.response, trendHeatmapConfiguration: { ...trendHeatmapConfig }, heatmapConfiguration: { ...heatmapConfig } }
  if (payload.response && payload.response.heatmapConfiguration) {
    return {
      ...state,
      trendHeatmapConfiguration: trendHeatmapConfig,
      heatmapConfiguration: payload.response.heatmapConfiguration,
      displayComparisonOptions: payload.response.heatmapConfiguration.comparisonColumn ? formatComparisonLevelForDisplay(payload.response.heatmapConfiguration.comparisonColumn) : [],
      thresholdApi: {
        data: payload.response,
        isProcessing: false,
        error: false
      }
    }
  }
  return {
    ...state,
    trendHeatmapConfiguration: trendHeatmapConfig,
    heatmapConfiguration: heatmapConfig,
    thresholdApi:{
      data:payload.response,
      isProcessing: false,
      error:false
    }
  };
};

export const getThresholdValueFail = (state, payload) => {
  return {
    ...state,
    thresholdApi:{
      data:null,
      isProcessing: false,
      error:true
    }
  };
};